import {
    apiRequest,
    daftarpegawai,
    PromotionPegawaiCreate,
    daftarpangkat,
    PromotionPeriodDetail
} from "../../../../../services/adapters/kepegawaian/kenaikanpangkatService"

class CreateRepository {

    fetchCreate = async (query) => {
        return await apiRequest("post", PromotionPegawaiCreate, {
            body: query
        }, true)
    }
    fetchEmployee = async (query) => {
        return await apiRequest("get", daftarpegawai, {
            params: query
        }, true)
    }
    fetchRank = async (query) => {
        return await apiRequest("get", daftarpangkat, {
            params: query
        }, true)
    }
    
    fetchDetail = async (query, cancelToken) => {
        return await apiRequest("get", PromotionPeriodDetail, {
            cancelToken: cancelToken,
            params: query
        }, true)
    }

}

export default CreateRepository